/**
* jv.candidate.details.workflow.base.controller Module
*
* Description
*/
angular.module('jv.candidate.details.workflow.base.controller', [])
    .controller('jvCandidateDetailsWorkflowBaseController', ['$scope', '$routeParams', 'candidates', '$location', '$rootScope', '$filter', '$timeout', 'VideoInterviewInviteModalService', '$window', '$jobviteUrls', '$log',
        function($scope, $routeParams, candidates, $location, $rootScope, $filter, $timeout, VideoInterviewInviteModalService, $window, $jobviteUrls, $log){
            var APPROVE_REJECT_NOTE_MAX_LENGTH = 1024;
            function initialize() {
                $scope.step = {};
                $scope.candMsgModal = {};
                $scope.step.extraExpand = false;
                $scope.languageList = {};
                $scope.loading = [];
                $rootScope.isFormEditInProgress = false;
                //for select2
                $scope.employeeSearch = candidates.employeeSearch;
                $scope.goodTimeBaseUrl = $window.goodTimeBaseUrl;

                //Hired candidate Edit form
                $scope.editCandInfo = false;
                $scope.candidate = {};
                $scope.addHireRequest = {};
                /**
                 * Load Evaluation Modal Factory
                 */
                //$scope.evalModal = evalModal;
                $rootScope.miniHeader = {
                    show: false
                };

                // Scheduler related code
                $scope.resetScheduler();
            }
            initialize();

            function getWorkflowRendered() {
                $scope.getWorkflowSummary(0);
            }

            /* ===========================================================================
               cleanAdvancedSchedulerStorage
               * Remove all localStorage related to Advanced Scheduler session
               ========================================================================== */
            var cleanAdvancedSchedulerStorage = function() {
                $window.localStorage.removeItem('advancedSchedule_timeSlots');
                $window.localStorage.removeItem('advancedSchedule_proposedInterviewInformation');
                $window.localStorage.removeItem('advancedSchedule_finalSchedules');
            };

            if (!$scope.workSteps || ($rootScope.evaluations && $rootScope.evaluations.refresh)) {
                if ($scope.$parent.loading && $scope.$parent.loading.indexOf('candidates.getWorkflowSummary') === -1) {
                    if (($rootScope.evaluations && $rootScope.evaluations.refresh) || ($routeParams.readmode === '0')) {
                        $scope.getWorkflowSummary(0);

                        if ($rootScope.evaluations) {
                            $rootScope.evaluations.refresh = false;
                        }
                    } else {
                        $scope.getWorkflowSummary(1);
                    }
                } else {
                    $scope.flags.loading = false;
                }
            } else {
                $scope.flags.loading = false;
            }



            $scope.shlAssessment = function(val, stateId) {
                switch (val) {
                    case 'editLanguage':
                        $scope.getLanguageList(stateId);
                        break;
                    case 'register':
                        $scope.registerCanforAss(stateId);
                        break;
                    case 'invite':
                        $scope.inviteCandforAss(stateId);
                        break;
                    default:
                        break;
                }
            };

            $scope.hmRemind = function() {
                $scope.reminderModal.show = true;
                $scope.reminderModal.form = {
                    title: i18n.SEND_REMINDER,
                    name: 'SendReminderToHM'
                };
            };

            $scope.registerCanforAss = function(stateId) {
                $scope.flags.loading = true;
                candidates.registerCandAss($routeParams.applicationId, stateId, function(res) {
                    if (res.msgInfo === $scope.status.OK) {
                        $scope.showMsg('CANDIDATE_REGISTERED');
                        $scope.updateWorkflowActions();
                    }
                    $scope.flags.loading = false;
                }, function() {
                    $scope.flags.loading = false;
                });
            };

            $scope.candMsgModal.ok = function() {
                var bcc = [];

                angular.forEach($scope.candMsgModal.form.cc, function(obj) {
                    bcc.push(obj.eid);
                });

                if ($scope.candMsgModal.form.isAgency) {
                    if ($scope.candMsgModal.form.includeCand) {
                        bcc.push($scope.appDetails.application.userEId);
                    }
                }

                var data = {
                    bcc: bcc,
                    sendToAgency: $scope.candMsgModal.form.isAgency,
                    content: $scope.candMsgModal.form.content,
                    subject: $scope.candMsgModal.form.subject
                };

                if (!$scope.candMsgModal.form.isAgency) {
                    data.to = $scope.candMsgModal.form.toEId;
                }


                candidates.addMessage($routeParams.applicationId, $.param($scope.serializeObject(data), true), function(res) {
                    $scope.candMsgModal.show = false;
                    if (res.msgInfo === $scope.status.OK) {
                        candidates.saveShlAssessmentInviteDate($routeParams.applicationId, $scope.candMsgModal.stateId, function() {
                            // console.log();
                        }, function(err){
                            $log.error(err);
                        });

                        $scope.showMsg($scope.candMsgModal.successMsg);
                        $scope.updateWorkflowActions();
                    }
                });
            };

            $scope.candMsgModal.cancel = function() {
                $scope.candMsgModal.show = false;
            };

            $scope.$watch('candMsgModal.form.selectedTemplate', function(newVal) {
                if (newVal && newVal !== '') {
                    for (var i = 0; i < $scope.candMsgModal.form.template.length; i++) {
                        if ($scope.candMsgModal.form.template[i].EId === newVal) {
                            $scope.candMsgModal.form.content = $scope.candMsgModal.form.template[i].body;
                            $scope.candMsgModal.form.subject = $scope.candMsgModal.form.template[i].subject;
                            break;
                        }
                    }
                } else if (newVal === '') {
                    $scope.candMsgModal.form.content = '';
                    $scope.candMsgModal.form.subject = '';
                }
            });

            $scope.inviteCandforAss = function(stateId) {
                candidates.inviteCandAssessment($routeParams.applicationId, stateId, function(res) {
                    $scope.candMsgModal.show = true;
                    $scope.candMsgModal.title = i18n.INVITE_CAND_ASSESSMENT;
                    $scope.candMsgModal.form = {};
                    $scope.candMsgModal.successMsg = 'CANDIDATE_INVITED';
                    $scope.candMsgModal.stateId = stateId;

                    $scope.candMsgModal.form = {
                        isAgency: res.inviteCandidateAssessmentDetails.model.getInviteCandidateforAssessmentDetails.isAgencyCandidate || false
                    };

                    if ($scope.candMsgModal.form.isAgency) {
                        $scope.candMsgModal.form.to = res.inviteCandidateAssessmentDetails.model.getInviteCandidateforAssessmentDetails.agency.fullName;
                        $scope.candMsgModal.form.toEId = res.inviteCandidateAssessmentDetails.model.getInviteCandidateforAssessmentDetails.agency.EId;
                    } else {
                        $scope.candMsgModal.form.to = $scope.appDetails.application.candidate.firstName + ' ' + $scope.appDetails.application.candidate.lastName;
                        $scope.candMsgModal.form.toEId = $scope.appDetails.application.userEId;
                    }

                    if (res.inviteCandidateAssessmentDetails.model.getInviteCandidateforAssessmentDetails.isAgencyCandidate) {
                        $scope.candMsgModal.form.template = res.inviteCandidateAssessmentDetails.model.getInviteCandidateforAssessmentDetails.assessmentAgencyTemplate;
                    } else {
                        $scope.candMsgModal.form.template = res.inviteCandidateAssessmentDetails.model.getInviteCandidateforAssessmentDetails.assessmentTemplate;
                    }

                }, function(err) {
                    $log.error(err);
                });
            };

            $scope.languageList.next = function() {
                $scope.languageList.start = $scope.languageList.start + 10;
                $scope.languageList.page = $scope.languageList.page + 1;
                $scope.languageList.end = $scope.languageList.list.length > ($scope.languageList.page + 1) * 10 ? ($scope.languageList.page + 1) * 10 : $scope.languageList.list.length;
            };

            $scope.languageList.prev = function() {
                $scope.languageList.start = $scope.languageList.start - 10;
                $scope.languageList.page = $scope.languageList.page - 1;
                $scope.languageList.end = $scope.languageList.end - 10;
            };

            $scope.languageList.saveLanguage = function() {
                $scope.flags.loading = true;
                var data = {
                    languageCode: $scope.languageList.selectedLang || ''
                };

                if (!data.languageCode) {
                    $scope.flags.loading = false;
                    return false;
                }

                candidates.saveAssessmentLanguage($.param(data, true), $routeParams.applicationId, $scope.languageList.stateId, function(res) {
                    if (res.msgInfo === $scope.status.OK) {
                        $scope.showMsg('ASSESSMENT_LANGUAGE_SAVED');
                    }
                    $scope.languageList.showModal = false;
                    $scope.flags.loading = false;
                }, function() {
                    $scope.flags.loading = false;
                    $scope.languageList.showModal = false;
                });
            };

            $scope.getLanguageList = function(stateId) {
                $scope.flags.loading = true;
                candidates.getAssessmentLanguages($routeParams.applicationId, stateId, function(res) {
                    $scope.flags.loading = false;
                    $scope.languageList.stateId = stateId;
                    $scope.languageList.list = res.shlAssessmentLanguages.model.shlAssessmentLanguages || [];
                    $scope.languageList.page = 0;
                    $scope.languageList.start = 1;
                    $scope.languageList.end = $scope.languageList.list.length > 10 ? 10 : $scope.languageList.list.length;
                    $scope.languageList.showModal = true;
                }, function(err) {
                    $scope.flags.loading = false;
                    $log.error(err);
                });
            };

            $scope.postForm = function(data, path, target) {
                $('#twForm').removeData();
                var form = document.createElement('form');
                form.id = 'temporaryJobviteForm';
                form.setAttribute('method', 'post');
                if (!target) {
                    form.setAttribute('target', '_blank');
                } else {
                    form.setAttribute('target', target);
                }

                form.setAttribute('action', path);

                for (var key in data) {
                    var hiddenField = document.createElement('input');
                    hiddenField.setAttribute('type', 'hidden');
                    hiddenField.setAttribute('name', key);
                    hiddenField.setAttribute('value', data[key]);
                    form.appendChild(hiddenField);
                }

                $('#twForm').append(form);
                $('#temporaryJobviteForm').submit();
            };

            $scope.accessBckgrndReport = function(stateId) {
                $scope.flags.loading = true;
                candidates.getBckgrndReport($routeParams.applicationId, stateId, function(res) {
                    $scope.flags.loading = false;

                    var data = {
                        akey: res.accessBackgroundCheckReport.model.accessBackgroundCheckReport.akey,
                        clientid: res.accessBackgroundCheckReport.model.accessBackgroundCheckReport.clientid,
                        applicantid: res.accessBackgroundCheckReport.model.accessBackgroundCheckReport.applicantid,
                        fctn: res.accessBackgroundCheckReport.model.accessBackgroundCheckReport.fctn
                    };

                    var path = res.accessBackgroundCheckReport.model.accessBackgroundCheckReport.talentWiseEndpoint;
                    $scope.postForm(data, path);
                }, function(err) {
                    $log.error(err);
                });
            };

            $scope.startBackgroundCheck = function(stateId) {
                $scope.flags.loading = true;
                candidates.getStartBckgrndCheck($routeParams.applicationId, stateId, function(res) {
                    $scope.flags.loading = false;

                    var data = {
                        akey: res.startBackgroundCheck.model.startBackgroundCheck.akey,
                        clientid: res.startBackgroundCheck.model.startBackgroundCheck.clientid,
                        ApplicantXml: res.startBackgroundCheck.model.startBackgroundCheck.ApplicantXml,
                        fctn: res.startBackgroundCheck.model.startBackgroundCheck.fctn
                    };

                    var path = res.startBackgroundCheck.model.startBackgroundCheck.talentWiseEndpoint;
                    $scope.postForm(data, path);
                }, function(err) {
                    $log.error(err);
                });
            };

            $scope.submitEval = function(step) {
                var url = 'evaluations-submit/' + $routeParams.applicationId + '/' + step.workflowElementInfo.EId;
                //Temp hack need to find a better way to do this
                var hasInterviewId = false;
                $rootScope.sendInterviewEId = false;
                for (var i = 0; i < step.model.interviews.length; i++) {
                    if (step.model.interviews[i].user.EId === window.jvUser && !step.model.interviews[i].completed) {
                        hasInterviewId = true;
                        $location.path(url + '/' + step.model.interviews[i].EId);
                    }
                }
                if (!hasInterviewId) {
                    $location.path(url);
                }
            };

            $scope.viewEval = function(step) {
                $rootScope.miniHeader = {
                    show: true,
                    back: 'workflow/' + $routeParams.applicationId
                };
                $rootScope.evaluations = null;
                $location.path('evaluations/' + $routeParams.applicationId + '/list/' + step.workflowElementInfo.EId);
            };

            $scope.printInterview = function(step, groupId) {
                var interviewSchedule = {
                    schedule: step.model.interviews,
                    info: step.workflowElementInfo,
                    isLocationEnabled: step.model.isLocationEnabled,
                    candName: $scope.appDetails.application.candidate.firstName + ' ' + $scope.appDetails.application.candidate.lastName,
                    jobName: $scope.appDetails.application.job.title
                };

                if(angular.isDefined(groupId)){
                    interviewSchedule.groupId = groupId;
                }

                $window.localStorage.interviewSchedule = angular.toJson(interviewSchedule);

                var printView = window.open('../candidates/details/workflow/interviewSchedulePopout.html?applicationId='+$scope.params.applicationId,'scrollbars=yes'); // eslint-disable-line
            };

            $scope.scheduleModifyInterview = function(step, mode, groupId) {
                // TODO: remove from rootscope and move to parent
                var applicationID = $routeParams.applicationId,
                    workflowStepID = step.workflowElementInfo.EId,
                    hasAdvancedSchedulerEnabled = step.model.advancedSchedulerEnabled,
                    hasModifyAdvanceSchedulerEnabled = !step.model.modifyAdvancedSchedulerDisabled,
                    route,
                    jobId;

                if ($scope.appDetails.application.job) {
                    if ($scope.appDetails.application.job.EId) {
                        jobId = $scope.appDetails.application.job.EId;
                    } else {
                        jobId = 'onV9Vfw6'; //0 - General Application
                    }
                }

                $scope.$parent.mode = $scope.mode = mode;
                $scope.setMode(mode, step);
                $rootScope.interviewStatus = step.workflowElementInfo.metaModel.interviewStatus;

                if (step.workflowElementInfo.metaModel.interviewStatus === 'Schedule' && mode !== 'modifyMessage') {
                    route = 'workflow-scheduler/';

                    if($window.enableSelfScheduling && mode === 'request'){
                        $window.location.href = $window.jvUrls.jhire +
                            '/modules/candidates/details/workflow/selfScheduler.html#/' +
                            'scheduler/'+$routeParams.applicationId +
                            '/' + step.workflowElementInfo.EId;

                            return;
                    } else if(hasAdvancedSchedulerEnabled && mode === 'modifySchedule' && hasModifyAdvanceSchedulerEnabled){
                        cleanAdvancedSchedulerStorage();

                        $window.location.href = $window.jvUrls.jhire +
                            '/modules/candidates/details/workflow/advancedScheduler.html?appid=' +
                            $routeParams.applicationId +
                            '&wfsid=' + step.workflowElementInfo.EId + '&jobid=' + jobId +
                            '#/proposedSchedule/modify/'+(groupId?groupId:1);

                        return;
                    }
                } else {
                    route = 'workflow-messager/';
                }

                route += applicationID + '/' + workflowStepID;

                if (groupId) {
                    route += '/' + groupId;
                }

                /* ==========================================================================
                   Bug HIRE-562 - ACM - 05/19/14
                   * Reason
                   * Checks whether a company has advanced scheduler enabled.
                   * If a customer has advanced scheduler enabled, then ensure that the user
                   * is still taken to modify message or modify schedule pages.
                   ========================================================================== */
                var interviewType = step.workflowElementInfo.metaModel.interviewStatus;
                if(($window.enableSelfScheduling && mode === 'request') && mode !== 'modifyMessage' && interviewType ==='Schedule'){
                    $location.path(route);
                }else{
                    if (!hasAdvancedSchedulerEnabled ||
                            (hasAdvancedSchedulerEnabled && (mode === 'modifyMessage' || mode === 'modifySchedule')) ||
                            (hasAdvancedSchedulerEnabled && (interviewType === 'Deadline' || interviewType === 'NoSchedule')) ) {
                        $location.path(route);
                    } else {
                        cleanAdvancedSchedulerStorage();

                        // Change the URL to the new Advanced Scheduler page
                        $window.location.href = $window.jvUrls.jhire +
                                                '/modules/candidates/details/workflow/advancedScheduler.html?appid=' +
                                                $routeParams.applicationId +
                                                '&wfsid=' + step.workflowElementInfo.EId + '&jobid=' + jobId +
                                                '#/interviewInformation';
                    }
                }
            };

            $scope.scheduleWithGoodTime = function (step) {
                window.open($window.goodTimeUrl.format($routeParams.applicationId,$scope.appDetails.application.candidate.EId,step.workflowElementInfo.EId));
            };

            $scope.offerApprovalAction = function(value, stateId) {
                var toList = [];
                var toName = [];
                if (value === 'viewOffer') {
                    $scope.$parent.offer = {};
                    $scope.$parent.offer.editMode = false;
                    $window.localStorage.setItem('offerDetails', JSON.stringify($scope.$parent.offer));
                    $location.path('workflow-offerLetter/' + $routeParams.applicationId + '/' + stateId);
                } else if (value === 'generateOffer' || value === 'regenerateOffer') {
                    $scope.$parent.offer = $scope.$parent.offer || {};
                    $scope.$parent.offer.editMode = true;
                    $window.localStorage.setItem('offerDetails', JSON.stringify($scope.$parent.offer));
                    $scope.generateOffer(stateId);
                } else if (value === 'remindOfferApprover') {
                    $scope.flags.loading = true;

                    candidates.getRemindApprover($routeParams.applicationId, function(res) {
                        $scope.flags.loading = false;

                        for (var i = 0; i < res.resendOfferApproval.model.messageDataItem.to.length; i++) {
                            toName.push(res.resendOfferApproval.model.messageDataItem.to[i].firstName + ' ' + res.resendOfferApproval.model.messageDataItem.to[i].lastName);
                            toList.push(res.resendOfferApproval.model.messageDataItem.to[i].EId);
                        }

                        $rootScope.modal.form = {
                            to: toName.join(' ,'),
                            to_label: true,
                            to_list: toList,
                            hideCC: true,
                            subject: res.resendOfferApproval.model.messageDataItem.subject || '',
                            content: res.resendOfferApproval.model.messageDataItem.content || ''
                        };

                        $rootScope.modal.title = i18n.REMINDOFFERAPPROVER;
                        $rootScope.modal.show = true;

                    }, function() {
                        $scope.flags.loading = false;
                    });
                } else if (value === 'retractOffer') {
                    $scope.flags.loading = true;
                    candidates.getRetractApprover($routeParams.applicationId, function(res) {
                        $scope.flags.loading = false;
                        if (angular.isDefined(res.retractOfferTemplate.model.retractOffer.to)) {
                            for (var i = 0; i < res.retractOfferTemplate.model.retractOffer.to.length; i++) {
                                toName.push(res.retractOfferTemplate.model.retractOffer.to[i].firstName + ' ' + res.retractOfferTemplate.model.retractOffer.to[i].lastName);
                                toList.push(res.retractOfferTemplate.model.retractOffer.to[i].EId);
                            }

                            $rootScope.modal.form = {
                                to: toName.join(' ,'),
                                to_label: true,
                                to_list: toList,
                                subject: res.retractOfferTemplate.model.retractOffer.subject || '',
                                content: res.retractOfferTemplate.model.retractOffer.content || '',
                                locale: res.retractOfferTemplate.model.retractOffer.locale || ''
                            };

                            $rootScope.modal.title = i18n.RETRACTOFFER;
                            $rootScope.modal.show = true;
                        } else {
                            $scope.showMsg('OFFER_APPROVED_MSG');
                        }

                    }, function(err) {
                        $log.error(err);
                        $scope.flags.loading = false;
                    });
                } else if (value === 'approveOffer') {
                    $scope.$parent.candAppRej.context = i18n.ENTER_NOTE;
                    $scope.$parent.candAppRej.approveCand = true;
                    $scope.$parent.candAppRej.checkContent = false;
                    $scope.$parent.candAppRej.isOptional = true;
                    $scope.$parent.candAppRej.title = i18n.APPROVE_OFFER;
                    $scope.$parent.candAppRej.button = i18n.APPROVE;
                    $scope.$parent.candAppRej.modal = 'approveOffer';
                    $scope.$parent.candAppRej.maxLength = APPROVE_REJECT_NOTE_MAX_LENGTH;
                } else if (value === 'rejectOffer') {
                    $scope.$parent.candAppRej.context = i18n.ENTER_NOTE;
                    $scope.$parent.candAppRej.approveCand = true;
                    $scope.$parent.candAppRej.checkContent = false;
                    $scope.$parent.candAppRej.isOptional = false;
                    $scope.$parent.candAppRej.title = i18n.REJECT_OFFER;
                    $scope.$parent.candAppRej.button = i18n.REJECT;
                    $scope.$parent.candAppRej.modal = 'rejectOffer';
                    $scope.$parent.candAppRej.maxLength = APPROVE_REJECT_NOTE_MAX_LENGTH;
                } else if (value === 'skipApprover') {
                    $scope.offerApproveReject(true);
                } else if (value === 'sendToAlternate') {
                    candidates.getAlternateMsg($routeParams.applicationId, function(res) {
                        $scope.$parent.modal.form = {
                            to_list: [],
                            hideCC: true,
                            subject: res.sendToAlternatesTemplate.model.sendToAlternates.subject || '',
                            content: res.sendToAlternatesTemplate.model.sendToAlternates.content || ''
                        };

                        for (var i = 0; i < res.sendToAlternatesTemplate.model.sendToAlternates.to.length; i++) {
                            $scope.$parent.modal.form.to_list.push(res.sendToAlternatesTemplate.model.sendToAlternates.to[i].EId);
                        }

                        $scope.$parent.modal.form.to = $scope.$parent.modal.form.to_list.join(',');

                        $scope.$parent.modal.title = i18n.SENDTOALTERNATE;
                        $scope.$parent.modal.show = true;
                    }, function(err) {
                        $log.error(err);
                    });
                }
            };

            $scope.modal.cancel = function() {
                $rootScope.modal.show = false;
                $rootScope.modal.form = {};
            };

            $scope.modal.ok = function() {
                $scope.flags.loading = true;
                var data = {
                    subject: $rootScope.modal.form.subject,
                    content: $rootScope.modal.form.content,
                    locale: $rootScope.modal.form.locale
                };

                if ($rootScope.modal.form.to_list) {
                    data.to = $rootScope.modal.form.to_list;

                    data.cc = [];
                    if ($rootScope.modal.form.cc) {
                        for (var i = 0; i < $rootScope.modal.form.cc.length; i++) {
                            data.cc.push($rootScope.modal.form.cc[i].EId);
                        }
                    }
                } else {
                    data.to = [];
                    for (var j = 0; j < $rootScope.modal.form.cc.length; j++) {
                        data.to.push($rootScope.modal.form.cc[j].EId);
                    }
                }

                if ($rootScope.modal.title === i18n.RETRACTOFFER) {
                    candidates.postRetractApprover($routeParams.applicationId, $scope.serializeObject(data), function(res) {
                        $scope.flags.loading = false;
                        $rootScope.modal.show = false;
                        $scope.$parent.modal.form = {};
                        if (res.msgInfo === 200) {
                            $scope.showMsg('OFFER_RETRACTED');
                            $scope.updateWorkflowActions();
                        }
                    }, function() {
                        $scope.flags.loading = false;
                        $rootScope.modal.show = false;
                    });
                } else if ($rootScope.modal.title === i18n.REMINDOFFERAPPROVER) {
                    candidates.postRemindApprover($routeParams.applicationId, $scope.serializeObject(data), function(res) {
                        $scope.flags.loading = false;
                        $rootScope.modal.show = false;
                        $scope.$parent.modal.form = {};
                        if (res.msgInfo === 200) {
                            $scope.showMsg('OFFER_REMINDED');
                            $scope.updateWorkflowActions();
                        }
                    }, function() {
                        $scope.flags.loading = false;
                        $rootScope.modal.show = false;
                    });
                } else if ($scope.$parent.modal.title === i18n.SENDTOALTERNATE) {
                    candidates.postAlternateMsg($routeParams.applicationId, $scope.serializeObject(data), function(res) {
                        $scope.flags.loading = false;
                        $scope.$parent.modal.show = false;
                        $scope.$parent.modal.form = {};
                        if (res.msgInfo === $scope.status.OK) {
                            $scope.showMsg('MESSAGE_SENT');
                            $scope.updateWorkflowActions();
                        }
                    }, function() {
                        $scope.flags.loading = false;
                        $scope.$parent.modal.form = {};
                        $rootScope.modal.show = false;
                    });
                }
            };

            $scope.getWorkflowDetails = function(stateId, isClosed) {
                if (isClosed) {
                    $scope.workflowStateId = stateId;

                    candidates.getWorkflowDetails($routeParams.applicationId, stateId, function(res) {
                        for (var i = 0; i < $scope.workSteps.length; i++) {
                            if ($scope.workSteps[i].workflowElementInfo.EId === stateId) {
                                if (res.workflowActivities.elementActions) {
                                    res.workflowActivities.elementActionsArr = [];
                                    angular.forEach(res.workflowActivities.elementActions, function(action, key) {
                                        action.title = key;
                                        if (res.workflowActivities.model.isDocuSignIntegrationEnabled && res.workflowActivities.model.showSigningOrder && (res.workflowActivities.model.offerKind === 'ESigGenerated' || res.workflowActivities.model.offerKind === 'ESigUploaded') && action.title === 'sendOfferToCandidate') {
                                            action.title = 'sendOfferForSignature';
                                        }
                                        if (res.workflowActivities.model.isDocuSignIntegrationEnabled && res.workflowActivities.model.showSigningOrder && (res.workflowActivities.model.offerKind === 'ESigGenerated' || res.workflowActivities.model.offerKind === 'ESigUploaded')  && action.title === 'reSendOfferToCandidate') {
                                            action.title = 'reSendOfferForSignature';
                                        }
                                        res.workflowActivities.elementActionsArr.push(action);
                                    });
                                }
                                $scope.normalizeWorkflow(res.workflowActivities);
                                if ($scope.workSteps[i].model && $scope.workSteps[i].model.evaluation) {
                                    res.workflowActivities.model.evaluation = $scope.workSteps[i].model.evaluation;
                                }
                                // create userHash for video evaluations if its a video workflow step
                                if ($scope.workSteps[i].workflowElementInfo && $scope.workSteps[i].workflowElementInfo.metaModel && $scope.workSteps[i].workflowElementInfo.metaModel.candidateState && $scope.workSteps[i].workflowElementInfo.metaModel.candidateState.kind && $scope.workSteps[i].workflowElementInfo.metaModel.candidateState.kind === 'VIDEO_SCREEN') {
                                    var userHash = {};
                                    angular.forEach($scope.workSteps[i].model.users, function(value) {  // eslint-disable-line
                                        userHash[value.EId] = value;
                                    });
                                    res.workflowActivities.model.usersHash = userHash;
                                }

                                $scope.workSteps[i] = res.workflowActivities;
                                $scope.workSteps[i].expanded = true;
                                break;
                            }
                        }
                    });
                }
                return true;
            };

            $scope.hasMore = function() {
                return false;
            };

            $scope.accessOnBoardingReport = function(stateId) {
                $scope.flags.loading = true;
                candidates.getStartOnBoarding($routeParams.applicationId, stateId, function(res) {
                    $scope.flags.loading = false;

                    var data = {
                        akey: res.startOnBoarding.model.startOnBoarding.akey,
                        clientid: res.startOnBoarding.model.startOnBoarding.clientid,
                        clientcandidateid: $routeParams.applicationId
                    };

                    var path = res.startOnBoarding.model.startOnBoarding.talentWiseEndpoint + '?Fctn=9';
                    $scope.postForm(data, path);
                }, function(err) {
                    $log.error(err);
                });
            };

            $scope.startOnBoarding = function(stateId) {
                $scope.flags.loading = true;
                candidates.getStartOnBoarding($routeParams.applicationId, stateId, function(res) {
                    $scope.flags.loading = false;

                    var data = {
                        akey: res.startOnBoarding.model.startOnBoarding.akey,
                        clientid: res.startOnBoarding.model.startOnBoarding.clientid,
                        ApplicantXml: res.startOnBoarding.model.startOnBoarding.ApplicantXml
                    };

                    var path = res.startOnBoarding.model.startOnBoarding.talentWiseEndpoint + '?Fctn=8';
                    $scope.postForm(data, path);
                }, function(err) {
                    $log.error(err);
                });
            };

            $scope.startOnBoardingRC = function(stateId) {
                $scope.flags.loading = true;
                candidates.getStartOnBoardingRC($routeParams.applicationId, stateId, function(res) {
                    $scope.flags.loading = false;

                    var data = {
                        AuthenticationToken: res.startOnBoardingRC.akey,
                        NewHireXML: res.startOnBoardingRC.ApplicantXml,
                        RedirectURL: res.startOnBoardingRC.redirectUrl
                    };

                    if (res.startOnBoardingRC.errorMsg) {
                        $scope.showMsg(res.startOnBoardingRC.errorMsg,false,'error');
                    } else {
                        var path = res.startOnBoardingRC.endpoint + res.startOnBoardingRC.endpointPath;
                        $scope.postForm(data, path, '_self');
                    }
                }, function(err) {
                    $log.error(err);
                });
            };

            $scope.resubmitOnBoardingCancel = function(stateId) {
                $scope.flags.loading = true;
                candidates.getStartOnBoarding($routeParams.applicationId, stateId, function(res) {
                    $scope.flags.loading = false;

                    var data = {
                        akey: res.startOnBoarding.model.startOnBoarding.akey,
                        clientid: res.startOnBoarding.model.startOnBoarding.clientid,
                        clientcandidateid: $routeParams.applicationId
                    };

                    var path = res.startOnBoarding.model.startOnBoarding.talentWiseEndpoint + '?Fctn=9';
                    $scope.postForm(data, path);
                }, function(err) {
                    $log.error(err);
                });
            };

            $scope.resubmitOnBoarding = function(stateId) {
                $scope.flags.loading = true;
                candidates.getStartOnBoarding($routeParams.applicationId, stateId, function(res) {
                    $scope.flags.loading = false;

                    var data = {
                        akey: res.startOnBoarding.model.startOnBoarding.akey,
                        clientid: res.startOnBoarding.model.startOnBoarding.clientid,
                        clientcandidateid: $routeParams.applicationId
                    };

                    var path = res.startOnBoarding.model.startOnBoarding.talentWiseEndpoint + '?Fctn=9';
                    $scope.postForm(data, path);
                }, function(err) {
                    $log.error(err);
                });
            };


            $scope.accessBackgroundHRReport = function(stateId) {
                $scope.flags.loading = true;
                candidates.getBackgroundHRReport($routeParams.applicationId, stateId, function(res) {
                    $scope.flags.loading = false;

                    var data = {};

                    var path = res.accessBackgroundCheckReport.model.accessBackgroundCheckReport.partnerEndpoint;
                    $scope.postForm(data, path);
                }, function(err) {
                    $log.error(err);
                });
            };

            $scope.startBackgroundCheckHR = function(stateId) {
                $scope.flags.loading = true;
                candidates.getstartBackgroundCheckHR($routeParams.applicationId, stateId, function(res) {
                    $scope.flags.loading = false;

                    var data = {

                    };

                    var path = res.startBackgroundCheck.model.startBackgroundCheck.partnerEndpoint;
                    $scope.postForm(data, path);
                }, function(err) {
                    $log.error(err);
                });
            };



            // Video actions;
            // if formResponseId and workflowStep and workflowStepId are present then it means its a reinvite for the candidate.
            $scope.sendVideoInterview = function(workflowStepId, workflowStateKind, formResponseId) {
                var workflowObject = null;
                if (angular.isDefined(workflowStepId)) {
                    workflowObject = {};
                    workflowObject.stateId = workflowStepId;
                    workflowObject.workflowStateKind = workflowStateKind;
                    workflowObject.formResponseId = formResponseId;
                }
                var fullName =  $scope.appDetails.application.candidate.firstName + ' ' + $scope.appDetails.application.candidate.lastName;
                // update UI with the promise.
                var promise = VideoInterviewInviteModalService.inviteCandidates(fullName, $scope.appDetails.application.EId, workflowObject,  $scope.appDetails.application.job.EId);
                workflowObject = null;
                promise.then(function(ifChangeWorkflowStepForVideo) {
                    if (ifChangeWorkflowStepForVideo) {
                        getWorkflowRendered();
                    }
                });
            };

            //Send Reminder Modal
            $scope.sendReminder = function(id) {
                $rootScope.$broadcast('sendReminderModalClick', id);
            };

            $scope.inviteReviewers = function(SId, appId) {
                $rootScope.$broadcast('SHOW_VIDEO_INVITE_MODAL', SId, appId);
            };

            $scope.remindReviewers = function(pendingEvaluators, users, id) {
                var userHash = {};
                angular.forEach(users, function(value, key) {
                    userHash[users[key].EId] = value;
                });
                var _pendingEvaluators = {};
                angular.forEach(pendingEvaluators, function(value, key) {
                    _pendingEvaluators[key] = userHash[value.userEId];
                });
                $rootScope.$broadcast('evalSendReminder', _pendingEvaluators, id);
            };

            $scope.previewQuestionnaire = function(questionnaireId) {
                $rootScope.$broadcast('previewOnlyQuestionnaire', questionnaireId);
                if(angular.isUndefined($scope.lazyLoading.videoPreviewTemplateUrl)){
                    $scope.lazyLoading.videoPreviewTemplateUrl = $jobviteUrls.video +'/video/recruiter/previewVideoInterviewModal.html';
                }
            };
            $scope.gotoForms = function(forms){
                $scope.$parent.inviteForms = forms;
                $scope.$parent.viewFormFlow = true;
                $location.path('application/'+$scope.params.applicationId);
            };

            $scope.voidOfferletterModal = function(){
                $scope.$parent.candAppRej.approveCand = true;
                $scope.$parent.candAppRej.checkContent = false;
                $scope.$parent.candAppRej.isOptional = false;
                $scope.$parent.candAppRej.title = i18n.VOIDOFFERLETTER;
                $scope.$parent.candAppRej.button = i18n.VOID_OFFER;
                $scope.$parent.candAppRej.context = i18n.VOID_OFFER_MODAL_HEADER;
                $scope.$parent.candAppRej.maxLength = APPROVE_REJECT_NOTE_MAX_LENGTH;
                $scope.$parent.candAppRej.modal = 'voidOffer';

                var data = {    // eslint-disable-line
                    reason: angular.copy($scope.offerLetterVoidReason)
                };
            };

            $scope.hasESigCC = function(users){
                if(users && users.length > 0){
                    for(var i=0; i<users.length; i++){
                        if(users[i].type === 'CarbonCopy'){
                            return true;
                        }
                    }
                }
                return false;
            };

            $scope.getESigCC = function(users){
                var tempUsers=[];
                if(users && users.length > 0){
                    for(var i=0; i<users.length; i++){
                        if(users[i].type === 'CarbonCopy'){
                            tempUsers.push(users[i]);
                        }
                    }
                }
                return tempUsers;
            };

            $scope.$on('setWorkflowAsPreSelected', function(event, data){
                $scope.getWorkflowDetails(data.stateEId, true);
                $timeout(function() {
                    // Auto scroll to selected workflow state
                    const element = $('.accordion-large > li:eq({0})'.format(data.stepIndex))[0];
                    if (element) {
                        element.scrollIntoView({ block: 'center', behavior: 'smooth' });
                    }
                }, 1000);
            });
    }]);